import { FC, useEffect } from 'react';

import AppLayout from 'pages/App';
import AuthLayout from 'pages/Auth';
import useAuth from 'store/auth';
import useMount from 'hooks/useMount';
import useCurrencies from 'store/currencies';
import useConfiguration from 'store/configuration';
import useSockets from 'hooks/useSocket';

import Metatags from './Metatags';

const Pages: FC = () => {
  const { connect } = useSockets();

  const [authState] = useAuth();
  const [, currencyActions] = useCurrencies();
  const [, configurationActions] = useConfiguration();

  useMount(() => {
    currencyActions.getPublic();
    configurationActions.getPublic();
  });

  const affiliateId = authState?.data?.affiliate?.id;

  useEffect(() => {
    if (affiliateId) {
      connect();
    }
  }, [affiliateId, connect]);

  return (
    <>
      <Metatags />
      {authState?.data?.accessToken && authState?.data?.affiliate?.id ? <AppLayout /> : <AuthLayout />}
    </>
  );
};

export default Pages;
